import { render, staticRenderFns } from "./DeleteResourceDetailContentSectionConfirmationDialog.vue?vue&type=template&id=eb0ba550"
import script from "./DeleteResourceDetailContentSectionConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./DeleteResourceDetailContentSectionConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports